import * as T from '../constants/types';

export const changeMapLoaded = isMapLoaded => ({ type: T.MAP_LOADED, payload: { isMapLoaded } });
export const changeMapLayersLoaded = isLayersLoaded => {
    return { type: T.MAP_LAYERS_LOADED, payload: { isLayersLoaded } };
};
export const setSelectedDateFromTiles = selectedDate => ({ type: T.SET_SELECTED_DATE_FROM_TILES, payload: { selectedDate } });
